import { render, staticRenderFns } from "./DatePickerUIDecorator.vue?vue&type=template&id=583977d4&"
import script from "./DatePickerUIDecorator.vue?vue&type=script&lang=js&"
export * from "./DatePickerUIDecorator.vue?vue&type=script&lang=js&"
import style0 from "./DatePickerUIDecorator.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports